import { Navigate, Route, useParams, generatePath } from 'react-router';
import ConfigData from 'config/ConfigData';

const Redirect = ({ to, replace, state }) => {
  const params = useParams();
  const redirectWithParams = generatePath(to, params);

  return <Navigate to={redirectWithParams} replace={replace} state={state} />;
};

const Redirections = (location) => {
  const locationComplete = `${location.search}${location.hash}`;
  return (
    <>
      <Route path={`/reference`} element={<Navigate to={`/reference/key-updates${location.search}`} />} />

      <Route
        path={`/monitor-inbox/calendar`}
        element={<Navigate replace to={`/monitor-inbox/upcoming-events${location.search}`} />}
      />
      {/* Redirecting monitor stakeholder urls */}
      <Route exact path={`/monitor/stakeholders`} element={<Navigate to='/people/stakeholder-mapping' />} />

      {/* REDIRECT LIST ROUTES */}
      <Route
        exact
        path={`/monitor/key-updates`}
        element={
          <Navigate to={`/monitor-inbox/${ConfigData?.monitorInboxInitialPage ?? 'key-updates'}${location.search}`} />
        }
      ></Route>

      <Route
        exact
        path={`/monitor/consultations`}
        element={<Navigate to={`/monitor-inbox/consultations${location.search}`} />}
      />

      <Route
        exact
        path={`/monitor/legislation`}
        element={<Navigate to={`/monitor-inbox/legislation${location.search}`} />}
      />

      <Route
        exact
        path={`/monitor/parliamentary-record`}
        element={<Navigate to={`/monitor-inbox/parliamentary-record${location.search}`} />}
      />

      <Route
        exact
        path={`/monitor/calendar`}
        element={<Navigate to={`/monitor-inbox/upcoming-events${location.search}`} />}
      />

      <Route
        exact
        path={`/monitor-inbox/calendar`}
        element={<Navigate to={`/monitor-inbox/upcoming-events${location.search}`} />}
      />

      <Route exact path={`/monitor/tweets`} element={<Navigate to={`/monitor-inbox/tweets${location.search}`} />} />

      {/* REDIRECT CONTENT ROUTES */}
      <Route
        exact
        path={`/monitor/key-updates/:id`}
        element={<Redirect to={`/key-updates/:id${locationComplete}`} />}
      />
      <Route
        exact
        path={`/monitor/key-updates/:id/:title`}
        element={<Redirect to={`/key-updates/${locationComplete}`} />}
      />

      <Route
        exact
        path={`/monitor/consultations/:id`}
        element={<Redirect to={`/consultations/:id${locationComplete}`} />}
      />

      <Route
        exact
        path={`/monitor/consultations/:id/:title`}
        element={<Redirect to={`/consultations/:id/:title${locationComplete}`} />}
      />

      <Route
        exact
        path={`/monitor/legislation/:type/:id`}
        element={<Redirect to={`/legislation/:type/:id${locationComplete}`} />}
      />

      <Route
        exact
        path={`/monitor/legislation/:type/:id/:title`}
        element={<Redirect to={`/legislation/:type/:id/:title${locationComplete}`} />}
      />

      <Route
        exact
        path={`/monitor/parliamentary-record/:type/:id`}
        element={<Redirect to={`/parliamentary-record/:type/:id${locationComplete}`} />}
      />

      <Route
        exact
        path={`/monitor/parliamentary-record/:type/:id/:title`}
        element={<Redirect to={`/parliamentary-record/:type/:id/:title${locationComplete}`} />}
      />

      <Route
        exact
        path={`/influence/stakeholders/:id`}
        element={<Redirect to={`/stakeholders/:id${locationComplete}`} />}
      />

      <Route
        exact
        path={`/influence/stakeholders/:id/:name`}
        element={<Redirect to={`/stakeholders/:id/:name${locationComplete}`} />}
      />

      <Route
        exact
        path={`/influence/stakeholders/:id/:name/:contentType`}
        element={<Redirect to={`/stakeholders/:id/:name/:contentType${locationComplete}`} />}
      />

      <Route
        exact
        path={`/monitor/stakeholders/:id`}
        element={<Redirect to={`/stakeholders/:id${locationComplete}`} />}
      />

      <Route
        exact
        path={`/monitor/stakeholders/:id/:name`}
        element={<Redirect to={`/stakeholders/:id/:name${locationComplete}`} />}
      />

      <Route
        exact
        path={`/stakeholders/:id/:name/early-day-motions-supported`}
        element={
          <Redirect
            to={`/stakeholders/:id/:name/early-day-motions-as-primary-sponsor-or-supporter${locationComplete}`}
          />
        }
      />

      <Route
        exact
        path={`/monitor/stakeholders/:id/:name/early-day-motions-supported`}
        element={
          <Redirect
            to={`/stakeholders/:id/:name/early-day-motions-as-primary-sponsor-or-supporter${locationComplete}`}
          />
        }
      />

      <Route
        exact
        path={`/monitor/stakeholders/:id/:name/:contentType`}
        element={<Redirect to={`/stakeholders/:id/:name/:contentType${locationComplete}`} />}
      />

      <Route exact path={`/influence/contacts`} element={<Navigate to={`/people/directory`} />} />
      <Route exact path={`/influence/contacts/update/:id`} element={<Redirect to={`/people/directory/update/:id`} />} />

      <Route
        exact
        path={`/have-your-voice-heard`}
        element={<Navigate to={`/brief-policymakers/lobbying-material${locationComplete}`} />}
      />

      <Route
        exact
        path={`/influence/have-your-voice-heard/add-content`}
        element={<Navigate to={`/brief-policymakers/add-content${locationComplete}`} />}
      />

      <Route
        exact
        path={`/influence/have-your-voice-heard/:contentType/:id/:title`}
        element={<Redirect to={`/:contentType/:id/:title${locationComplete}`} />}
      />

      <Route
        exact
        path={`/influence/stakeholder-mapping`}
        element={<Redirect to={`/people/stakeholder-mapping${locationComplete}`} />}
      />

      <Route
        exact
        path={`/stakeholder-mapping`}
        element={<Redirect to={`/people/stakeholder-mapping${locationComplete}`} />}
      />

      <Route exact path={`/influence/directory`} element={<Redirect to={`/people/directory${locationComplete}`} />} />
      <Route exact path={`/influence/my-groups`} element={<Redirect to={`/people/my-groups${locationComplete}`} />} />
      <Route exact path={`/influence/my-groups/:groupId`} element={<Redirect to={`/people/my-groups/:groupId`} />} />
      <Route exact path={`/influence/emails`} element={<Redirect to={`/people/emails${locationComplete}`} />} />
      <Route
        exact
        path={`/influence/email-performance`}
        element={<Redirect to={`/people/email-performance${locationComplete}`} />}
      />
      <Route
        exact
        path={`/influence/lobbying-material`}
        element={<Redirect to={`/brief-policymakers/lobbying-material${locationComplete}`} />}
      />
      <Route
        exact
        path={`/influence/engagement-statistics`}
        element={<Redirect to={`/brief-policymakers/engagement-statistics${locationComplete}`} />}
      />

      <Route exact path={`/influence`} element={<Redirect to={`/people${locationComplete}`} />} />

      {/* REDIRECT SETTINGS PAGES */}
      <Route path='/keywords-and-alerts' element={<Navigate replace to='/settings/topics' />} />

      <Route path='/keywords' element={<Navigate replace to='/settings/topics' />} />

      <Route path='/keywords/:action' element={<Navigate replace to='/settings/topics' />} />

      <Route path='/email-alerts' element={<Navigate replace to='/settings/alerts' />} />

      <Route path='/my-topics' element={<Navigate replace to='/settings/topics' />} />

      <Route path='/my-team' element={<Navigate replace to='/settings/team' />} />
    </>
  );
};

const RedirectionsNoAuthenticated = (location) => {
  const loginUrl = `/login?returnUrl=${encodeURIComponent(`${location.pathname}${location.search}${location.hash}`)}`;
  return (
    <>
      <Route path={`/monitor-inbox`} element={<Navigate to={loginUrl} />} />
      <Route path={`/stakeholder-mapping`} element={<Navigate to={loginUrl} />} />
      <Route path={`/monitor-inbox/:page`} element={<Navigate to={loginUrl} />} />
      <Route path={`/analytics/:section`} element={<Navigate to={loginUrl} />} />
      <Route path={`/ai-assistant`} element={<Navigate to={loginUrl} />} />
      <Route path={`/ai-assistant/:section`} element={<Navigate to={loginUrl} />} />
      <Route path={`/ai-assistant/:section/:title`} element={<Navigate to={loginUrl} />} />
      <Route path={`/notes`} element={<Navigate to={loginUrl} />} />
      <Route path={`/notes/my-own`} element={<Navigate to={loginUrl} />} />
      <Route path={`/notes/my-teams`} element={<Navigate to={loginUrl} />} />
    </>
  );
};

export { Redirect, RedirectionsNoAuthenticated };
export default Redirections;
